/*
 * EditStudent Messages
 *
 * This contains all the text for the EditStudent component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    save: {
        id: 'app.components.EditStudent.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'app.components.EditStudent.cancel',
        defaultMessage: 'Cancel'
    },
    yearGroupList: {
        id: 'app.components.EditStudent.yearGroupList',
        defaultMessage: 'Year'
    }
});



// WEBPACK FOOTER //
// ./app/components/edit-student-form/messages.js